import React from 'react';
import * as S from './NoRefundCancelPop.styles';
import IconSelector from '@ibibo/icon-selector';

const NoRefundCancelPop = ({refundAmount, confirmCancellation, closeModal}) => {
    return(
      <S.CofirmPopOuterWrap>
        <S.ConfirmPopInnerWrap>
            <S.CofirmPopHeadText>Are you sure you want to Cancel?</S.CofirmPopHeadText>
            {refundAmount > 0 ? <>
              <S.ConfirmInfoText>Please confirm cancellation to cancel your booking. You are eligible for a refund amount of ₹{refundAmount.toLocaleString('en-IN')}</S.ConfirmInfoText>
            </> : <>
              <S.ConfirmInfoText><span class="redBoldText">You have to pay the entire room price as penalty </span>. You can choose to just keep the rooms.</S.ConfirmInfoText>
              <S.ConfirmInfoText><span class="blackboldText">This is the final step, as your refund is ₹{refundAmount.toLocaleString('en-IN')}.</span> Please confirm cancellation to cancel your booking.</S.ConfirmInfoText>
            </>}
        </S.ConfirmPopInnerWrap>
        <S.ConfirmPopBtnWrap>
          <S.BackButtonWrap onClick={closeModal}>
            <S.BackButton>Cancel</S.BackButton>
          </S.BackButtonWrap>
          <S.ConfirmCancelBtn onClick={confirmCancellation}>Confirm Cancellation</S.ConfirmCancelBtn>
        </S.ConfirmPopBtnWrap>
    </S.CofirmPopOuterWrap>
    );
}

export default NoRefundCancelPop;